import * as RTooltip from '@radix-ui/react-tooltip';
import { useState } from 'react';
import type { ReactNode } from 'react';

/** Lightweight label tooltip (Radix) — wrap any trigger element. Opens on
 * hover/focus, and on tap for touch devices (Radix tooltips don't open on
 * touch by default, so the trigger click force-opens it). */
export function Tooltip({
  label,
  children,
  side = 'top',
}: {
  label: ReactNode;
  children: ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
}) {
  const [open, setOpen] = useState(false);

  return (
    <RTooltip.Provider delayDuration={120} skipDelayDuration={300}>
      <RTooltip.Root open={open} onOpenChange={setOpen}>
        <RTooltip.Trigger asChild onClick={() => setOpen(true)}>
          {children}
        </RTooltip.Trigger>
        <RTooltip.Portal>
          <RTooltip.Content
            side={side}
            align="center"
            sideOffset={6}
            collisionPadding={12}
            className="z-[120] max-w-[min(90vw,20rem)] rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-medium leading-snug break-all text-sf-blue-dark shadow-xl select-none dark:border-white/10 dark:bg-sf-dark-gunmetal dark:text-white"
          >
            {label}
            <RTooltip.Arrow className="fill-white dark:fill-sf-dark-gunmetal" width={11} height={6} />
          </RTooltip.Content>
        </RTooltip.Portal>
      </RTooltip.Root>
    </RTooltip.Provider>
  );
}
